// extracted by mini-css-extract-plugin
export default {"loaderFixedContainer":"Loader_loaderFixedContainer__VZ6n3","loadingAnimation":"Loader_loadingAnimation__-IMBq","loading-animation":"Loader_loading-animation__dBlm2"};